import { render, staticRenderFns } from "./Teads.vue?vue&type=template&id=dc013e7e&"
import script from "./Teads.vue?vue&type=script&lang=js&"
export * from "./Teads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports